import * as React from "react";
import { ISection } from "../../../model/formconfiguration/Section";
import FormQualifierComponent from "./FormQualifierComponent";
import AddQualifierModal from "./AddQualifierModal";
import { Form, Typography, Table, Row } from "antd";
import CreateFormConfigSectionQualifierForm, {
  CreateFormConfigSectionQualifierFormProps
} from "./CreateFormConfigSectionQualifierForm";
import SelectExistingQualifierForm, {
  SelectExistingQualifierFormProps
} from "./SelectExistingQualifierForm";
import { IAttribute } from "../../../model/formconfiguration/Attribute";
import FormQualifierGridComponent from "../../components/formConfiguration/FormQualifierGridComponent";
import { IFormConfigSectionQualifier } from "../../../model/formconfiguration/FormConfigSectionQualifier";
import { IFormConfigQualifierAttribute } from "../../../service/formconfiguration/FormConfigQualifierAttribute";

export interface State {}

export interface Props {
  section: ISection;
  translate: any;
  onRemoveBtnClick: any;
  onCreateBtnClick: any;
  onClick: any;
  selectedFormElement?: any;
  createFormConfigSectionQualifier(
    parentFormSection: ISection,
    formConfigSectionQualifier: IFormConfigSectionQualifier
  ): any;
  qualifiers?: any;
  invalidateQualifier: any;
  createFormConfigQualifierAttribute(
    parentFormConifgSectionQualifier: IFormConfigSectionQualifier,
    formConfigQualifierAttribute: IFormConfigQualifierAttribute
  ): any;
  attributes?: IAttribute[];
  invalidateAttribute: any;
  showAddQualifierModal: any;
  addQualifierModalVisible?: boolean;
  hideAddQualifierModal: any;
  showAddAttributeModal: any;
  hideAddAttributeModal: any;
  showRemoveQualifierModal: any;
  hideRemoveQualifierModal: any;
  addAttributeModalVisible?: any;
  removeQualifierModalVisible?: any;
  hideInvalidateAttributeModal: any;
  invalidateAttributeModalVisible?: any;
  isSelectedComponent: any;
}

export default class FormSection extends React.Component<Props, State> {
  render() {
    const {
      section,
      translate,
      onRemoveBtnClick,
      onCreateBtnClick,
      onClick,
      selectedFormElement,
      createFormConfigSectionQualifier,
      qualifiers,
      invalidateQualifier,
      createFormConfigQualifierAttribute,
      attributes,
      invalidateAttribute,
      addQualifierModalVisible,
      showAddQualifierModal,
      hideAddQualifierModal,
      showAddAttributeModal,
      hideAddAttributeModal,
      showRemoveQualifierModal,
      hideRemoveQualifierModal,
      addAttributeModalVisible,
      removeQualifierModalVisible,
      hideInvalidateAttributeModal,
      invalidateAttributeModalVisible,
      isSelectedComponent
    } = this.props;

    const CreateQualifierFormComponent = Form.create<
      CreateFormConfigSectionQualifierFormProps
    >({})(CreateFormConfigSectionQualifierForm);

    const SelectExistingQualifierFormComponent = Form.create<
      SelectExistingQualifierFormProps
    >({})(SelectExistingQualifierForm);

    const renderSubsections = () => {
      let subsectionsRendered: JSX.Element[] = [];
      if (section && section.subsections && section.subsections.length > 0) {
        section.subsections.sort(function (a, b) {
          return a.orderNumber - b.orderNumber;
        });
        section.subsections.forEach((subsection) => {
          subsectionsRendered.push(
            <FormSection
              key={subsection.id}
              section={subsection}
              translate={translate}
              onRemoveBtnClick={onRemoveBtnClick}
              onCreateBtnClick={onCreateBtnClick}
              onClick={onClick}
              selectedFormElement={selectedFormElement}
              createFormConfigQualifierAttribute={
                createFormConfigQualifierAttribute
              }
              invalidateQualifier={invalidateQualifier}
              createFormConfigSectionQualifier={
                createFormConfigSectionQualifier
              }
              attributes={attributes}
              invalidateAttribute={invalidateAttribute}
              addQualifierModalVisible={addQualifierModalVisible}
              showAddQualifierModal={showAddQualifierModal}
              hideAddQualifierModal={hideAddQualifierModal}
              showAddAttributeModal={showAddAttributeModal}
              hideAddAttributeModal={hideAddAttributeModal}
              showRemoveQualifierModal={showRemoveQualifierModal}
              hideRemoveQualifierModal={hideRemoveQualifierModal}
              addAttributeModalVisible={addAttributeModalVisible}
              removeQualifierModalVisible={removeQualifierModalVisible}
              hideInvalidateAttributeModal={hideInvalidateAttributeModal}
              invalidateAttributeModalVisible={invalidateAttributeModalVisible}
              isSelectedComponent={isSelectedComponent}
              qualifiers={qualifiers}
            />
          );
        });
      }

      return subsectionsRendered;
    };

    const sortQualifiersByOrderNumber = (
      qualifiers: IFormConfigSectionQualifier[] = []
    ) => {
      return qualifiers.sort((a, b) => {
        return a.orderNumber - b.orderNumber;
      });
    };

    const renderQualifiersInline = (section: ISection) => {
      let qualifierRenderList: JSX.Element[] = [];
      if (section.qualifiers) {
        let sortedFormConfigSectionQualifiers = sortQualifiersByOrderNumber(
          section.qualifiers
        );

        sortedFormConfigSectionQualifiers.forEach(
          (formConfigSectionQualifier) => {
            qualifierRenderList.push(
              <Row>
                <FormQualifierComponent
                  key={formConfigSectionQualifier.qualifierCode}
                  formConfigSectionQualifier={formConfigSectionQualifier}
                  selectedFormElement={selectedFormElement}
                  onClick={onClick}
                  translate={translate}
                  invalidateQualifier={invalidateQualifier}
                  createFormConfigQualifierAttribute={
                    createFormConfigQualifierAttribute
                  }
                  attributes={attributes}
                  invalidateAttribute={invalidateAttribute}
                  hideAddAttributeModal={hideAddAttributeModal}
                  hideRemoveQualifierModal={hideRemoveQualifierModal}
                  addAttributeModalVisible={addAttributeModalVisible}
                  removeQualifierModalVisible={removeQualifierModalVisible}
                  hideInvalidateAttributeModal={hideInvalidateAttributeModal}
                  invalidateAttributeModalVisible={
                    invalidateAttributeModalVisible
                  }
                  parentSection={section}
                  isSelectedComponent={isSelectedComponent}
                />
              </Row>
            );
          }
        );
      }
      return qualifierRenderList;
    };

    const renderQualifiersGrid = (section: ISection) => {
      let columns: any[] = [];
      let rows: any[] = [];
      if (section.qualifiers && section.qualifiers.length !== 0) {
        let sortedQualifiers = sortQualifiersByOrderNumber(section.qualifiers);

        rows = getQualifierGridRows(section);

        sortedQualifiers.forEach(
          (formConfigSectionQualifier: IFormConfigSectionQualifier) => {
            columns.push({
              title: formConfigSectionQualifier.labelVisible
                ? formConfigSectionQualifier.label ||
                  formConfigSectionQualifier.qualifier.name
                : "",
              key: formConfigSectionQualifier.qualifierCode,
              width: formConfigSectionQualifier.width,
              render: (text: string, record: any, rowIndex: number) => {
                return (
                  <FormQualifierGridComponent
                    translate={translate}
                    removeQualifierModalVisible={removeQualifierModalVisible}
                    hideRemoveQualifierModal={hideRemoveQualifierModal}
                    selectedFormElement={selectedFormElement}
                    invalidateQualifier={invalidateQualifier}
                    addAttributeModalVisible={addAttributeModalVisible}
                    formConfigSectionQualifier={formConfigSectionQualifier}
                    hideAddAttributeModal={hideAddAttributeModal}
                    createFormConfigQualifierAttribute={
                      createFormConfigQualifierAttribute
                    }
                    attributes={attributes}
                    onClick={onClick}
                    invalidateAttribute={invalidateAttribute}
                    hideInvalidateAttributeModal={hideInvalidateAttributeModal}
                    invalidateAttributeModalVisible={
                      invalidateAttributeModalVisible
                    }
                    parentSection={section}
                    isSelectedComponent={isSelectedComponent}
                  />
                );
              },
              onHeaderCell: (column) => {
                return {
                  onClick: (e) => {
                    onClick(formConfigSectionQualifier);
                    e.stopPropagation();
                  },
                  className: `form-qualifier ${
                    isSelectedComponent(formConfigSectionQualifier) &&
                    "form-qualifier-selected"
                  }`
                };
              }
            });
          }
        );
        return (
          <Table
            key={section.id}
            columns={columns}
            dataSource={rows}
            pagination={false}
            bordered={true}
            scroll={{ x: true }}
          ></Table>
        );
      }
    };

    const getQualifierGridRows = (section: ISection) => {
      let rows: any[] = [];

      if (section.maxNumber !== -1) {
        for (let i = 0; i < section.maxNumber; i++) {
          rows.push({ key: i });
        }
      } else {
        rows.push({ key: 1 });
      }
      return rows;
    };

    const handleOnClickEvent = (e) => {
      onClick(section);
      e.stopPropagation();
    };

    return (
      <React.Fragment>
        <div
          style={{ paddingLeft: section.formSectionId ? "0em" : "1em" }}
          className={`form-section ${
            isSelectedComponent(section) && "form-section-focus"
          }`}
          onClick={handleOnClickEvent}
        >
          <h3>
            {`${section.orderNumberVisible ? `${section.orderNumber}.` : ""}
          ${section.labelVisible ? section.label : ""}`}
          </h3>

          {section.comment ? (
            <Typography.Text type="secondary">
              {section.comment}
            </Typography.Text>
          ) : null}
          <div style={{ marginLeft: 0 }}>{renderSubsections()}</div>
          {section.maxNumber && section.maxNumber === 1
            ? renderQualifiersInline(section)
            : renderQualifiersGrid(section)}
        </div>
        <AddQualifierModal
          translate={translate}
          visible={addQualifierModalVisible && isSelectedComponent(section)}
          onCancel={hideAddQualifierModal}
          CreateQualifierForm={CreateQualifierFormComponent}
          SelectExistingQualifierForm={SelectExistingQualifierFormComponent}
          createFormConfigSectionQualifier={createFormConfigSectionQualifier}
          qualifiers={qualifiers}
          parentFormSection={section}
        />
      </React.Fragment>
    );
  }
}
